// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Item
*/
export class TCQpSignatureModelItem {
    /**
    * @description Text
    */
    'text': string;
    /**
    * @description Value
    */
    'value': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureModelItem>> = [
        {
            "name":     "text",
            "baseName": "text",
            "type":     "string"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureModelItem.attributeTypeMap;
    }
}
